import type { ChallengeService } from '@duck/api-definitions'

// Resolves a URL slug to an available challenge. The slug in /challenges/<slug>
// is normally the task slug, but we also accept the challenge slug and the task
// id so any of the identifiers used elsewhere route correctly.
export const findChallengeBySlug = (
  challenges: ChallengeService.AvailableChallenge[],
  slug: string
): ChallengeService.AvailableChallenge | undefined =>
  challenges.find((c) => c.taskSlug === slug || c.slug === slug || c.taskId === slug)
